"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Main = _interopRequireDefault(require("./Main"));
var _ResourceCenters = _interopRequireDefault(require("./ResourceCenters"));
var _ResourceCenter = _interopRequireDefault(require("./ResourceCenters/ResourceCenter"));
var _HelpCenters = _interopRequireDefault(require("./HelpCenters"));
var _HelpCenter = _interopRequireDefault(require("./HelpCenters/HelpCenter"));
var _ReportCenters = _interopRequireDefault(require("./ReportCenters"));
var _ReportCenter = _interopRequireDefault(require("./ReportCenters/ReportCenter"));
var _Reports = _interopRequireDefault(require("./Reports"));
var _Report = _interopRequireDefault(require("./Reports/Report"));
var _Tables = _interopRequireDefault(require("./Tables"));
var _Table = _interopRequireDefault(require("./Tables/Table"));
var _General = _interopRequireDefault(require("./General"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = [{
  path: '',
  breadcrumb: 'Settings',
  component: _Main["default"]
}, {
  path: 'resourceCenters',
  breadcrumb: 'Resource Centers',
  component: _ResourceCenters["default"]
}, {
  path: 'resourceCenters.list[x]',
  breadcrumb: function breadcrumb(obj) {
    return obj.title;
  },
  component: _ResourceCenter["default"],
  componentPathProps: {
    icons: 'resourceCenters.icons',
    filterGroupIcons: 'resourceCenters.filterGroupIcons'
  }
}, {
  path: 'helpCenters',
  breadcrumb: 'Help Centers',
  component: _HelpCenters["default"]
}, {
  path: 'helpCenters.list[x]',
  breadcrumb: function breadcrumb(obj) {
    return obj.id;
  },
  component: _HelpCenter["default"]
}, {
  path: 'reportCenters',
  breadcrumb: 'Report Center',
  component: _ReportCenters["default"]
}, {
  path: 'reportCenters.list[x]',
  breadcrumb: function breadcrumb(obj) {
    return obj.id;
  },
  component: _ReportCenter["default"],
  componentPathProps: {
    tables: 'tables',
    reports: 'reports',
    icons: 'reportCenters.icons'
  }
}, {
  path: 'reports',
  breadcrumb: 'Reports',
  component: _Reports["default"]
}, {
  path: 'reports.list[x]',
  breadcrumb: function breadcrumb(obj) {
    return obj.id;
  },
  component: _Report["default"]
}, {
  path: 'customTables',
  breadcrumb: 'Tables',
  component: _Tables["default"]
}, {
  path: 'customTables.list[x]',
  breadcrumb: function breadcrumb(obj) {
    return obj.title;
  },
  component: _Table["default"]
}, {
  path: 'app',
  breadcrumb: 'General',
  component: _General["default"]
}];